import React from 'react';
import { useSpring } from '@isyc-react/animation/lib';
import clsx from 'clsx';
import { nanoid } from 'nanoid';
import { FormSize } from "../../../../view-model";
import { useFormCommonProps } from "../../../context/form-common";
import "./input-switch.style.scss";
export const InputSwitch = props => {
  const {
    onChange,
    onFocus,
    onBlur,
    value = false,
    error,
    size,
    readOnly,
    disabled,
    label,
    className,
    children,
    dataTestId
  } = useFormCommonProps(props);
  const initial = React.useRef(value);
  const {
    x
  } = useSpring({
    from: {
      x: initial.current ? 1 : 0
    },
    x: value ? 1 : 0,
    config: {
      mass: 5,
      tension: 2000,
      friction: 200
    }
  });
  const id = React.useMemo(() => nanoid(), []);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('form-check form-switch', {
      'form-switch-sm': size === FormSize.SM,
      'form-switch-lg': size === FormSize.LG,
      'form-switch-xl': size === FormSize.XL
    }, className)
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: "checkbox",
    "data-test-id": dataTestId,
    className: clsx('form-check-input', {
      'is-invalid': error
    }),
    tabIndex: 0,
    checked: value,
    disabled: disabled || readOnly,
    onChange: e => {
      const checked = e.target.checked;
      onChange && onChange(checked);
    },
    onFocus: () => onFocus && onFocus(),
    onBlur: () => onBlur && onBlur()
  }), (label || children) && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "form-check-label"
  }, label !== null && label !== void 0 ? label : children));
};